import { Languages } from "src/common/descriptions/types";
import { CustomerProfileDescriptions } from "./types";

const DescriptionsEnUs: CustomerProfileDescriptions = {
    TITLE: "Customer Profile",
    TABS: {
        DATA: "Information",
        CONTRACTS: "Contracts",
        PAYMENT_RECORDS: "Payment Records",
        CUSTOMER_ACCOUNT_PAYABLES: {
            TITLE: "Account Payables",
            OPTIONS: {
                SEND_ACCOUNT_BALANCE: {
                    TITLE: "Send Account Balance",
                    LOADING_TITLE: "Sending account balance...",
                    LOADING_DESCRIPTION: "Please wait while we send the account balance to the customer.",
                    CONFIRMATION: "Send account balance?",
                }
            },
        },
        OPTIONS: "Options",
    },
}

const DescriptionsEsUs: CustomerProfileDescriptions = {
    TITLE: "Perfil de Cliente",
    TABS: {
        DATA: "Información",
        CONTRACTS: "Contratos",
        PAYMENT_RECORDS: "Historial de Pagos",
        CUSTOMER_ACCOUNT_PAYABLES: {
            TITLE: "Cuentas por pagar",
            OPTIONS: {
                SEND_ACCOUNT_BALANCE: {
                    TITLE: "Enviar estado de cuenta",
                    LOADING_TITLE: "Enviando estado de cuenta...",
                    LOADING_DESCRIPTION: "Por favor, espere mientras enviamos el estado de cuenta al cliente.",
                    CONFIRMATION: "¿Enviar estado de cuenta?",
                }
            },
        },
        OPTIONS: "Opciones",
    },
}

export const customerProfileDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}